<div class="page-wrapper pt-4">
  <div class="">
    <div class="">
      <div class="default_class">
        <div class="content-wrapper p-0">
          <div class="container-fluid">
            <div class="row">
              <div class="col-xl-12">
                <div class="card rounded shadow-lg">
                  <!-- Dashboard Content -->
                  <div class="dashboard-content">
                    <!-- Updated page title and subtitle for SCDE -->
                    <h1 class="page-title">Subcounty Director Dashboard</h1>
                    <p class="page-subtitle">
                      {{subCountyName}} - Educational Management
                    </p>
                    <!-- Updated stats cards with SCDE-specific KPIs -->
                    <div class="row mb-4">
                      <div class="col md-2">
                        <div class="stat-card h-100 pointer" (click)="navigationUrl()">
                          <i class="fas fa-clipboard-list stat-icon"></i>
                          <div class="stat-number">{{dashboardDetails?.REGISTARATION_APPLICATIONS?.total}}</div>
                          <div class="stat-label">
                            Total Applications
                          </div>
                          <div class="stat-sublabel">Awaiting SCDE Review</div>
                        </div>
                      </div>
                      <div class="col md-2">
                        <div class="stat-card h-100 pointer" (click)="navigationUrl()">
                          <i class="fas fa-school stat-icon"></i>
                          <div class="stat-number">{{dashboardDetails?.TOTAL_INSITUTIONS?.total}}</div>
                          <div class="stat-label">Total Institutions</div>
                          <div class="stat-sublabel">In Subcounty</div>
                        </div>
                      </div>
                      <div class="col md-2">
                        <!-- Replaced SCQASO Assignment with Subject Combinations metric -->
                        <div class="stat-card h-100 pointer" (click)="navigationISUrl(5)">
                          <i class="fas fa-book-open stat-icon"></i>
                          <div class="stat-number">{{dashboardDetails?.PENDING_ASSIGNED_TO_SCQASO?.total}}</div>
                          <div class="stat-label">Schools received from CDE</div>
                          <div class="stat-sublabel">Pending Approval</div>
                        </div>
                      </div>
                      <div class="col md-2">
                        <div class="stat-card h-100 pointer" (click)="navigationTLUrl()">
                          <i class="fas fa-users stat-icon"></i>
                          <div class="stat-number">{{dashboardDetails?.TOTAL_LEARNERS?.total}}</div>
                          <div class="stat-label">Total Learners</div>
                          <div class="stat-sublabel">Subcounty Enrollment</div>
                        </div>
                      </div>
                      <div class="col md-2">
                        <!-- Replaced SCQASO Assignment with Subject Combinations metric -->
                        <div class="stat-card h-100 pointer" (click)="navgateToSCUrl()">
                          <i class="fas fa-book-open stat-icon"></i>
                          <div class="stat-number">{{dashboardDetails?.SUBJECT_COMBINATIONS_PENDING_APPROVAL?.total}}
                          </div>
                          <div class="stat-label">Subject Combinations</div>
                          <div class="stat-sublabel">Pending Approval</div>
                        </div>
                      </div>

                    </div>

                    <!-- Additional SCDE-specific metrics row -->
                    <div class="row mb-4">
                      <!-- Removed duplicate Subject Combinations card from second row -->
                    </div>

                    <!-- Charts Row -->
                    <div class="row mb-4">
                      <!-- Updated for SCDE submission action status -->
                      <div class="col-md-6 mb-2">
                        <div class="chart-card h-100">
                          <div class="chart-header">
                            <i class="fas fa-tasks me-2"></i>
                            <div>
                              <div class="chart-title">
                                Submission Action Status
                              </div>
                              <div class="chart-subtitle">
                                Current status of institution submissions
                              </div>
                            </div>
                          </div>
                          <div class="chart-body">
                            <div class="progress-item">
                              <div class="progress-label">
                                <span style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    background-color: #00adee;
                                    border-radius: 2px;
                                    margin-right: 8px;
                                  "></span>
                                Completed
                              </div>
                              <div class="progress-bar-container">
                                <div class="progress-bar-fill success"
                                  [style.width.%]="((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.total || 0) * 100) / ((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.total || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending || 0) || 1)">
                                </div>
                              </div>
                              <div class="progress-value">{{dashboardDetails?.SUBMISSION_ACTION_STATUS?.total}}</div>
                            </div>
                            <div class="progress-item">
                              <div class="progress-label">
                                <span style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    background-color: #ffc107;
                                    border-radius: 2px;
                                    margin-right: 8px;
                                  "></span>
                                In Progress
                              </div>
                              <div class="progress-bar-container">
                                <div class="progress-bar-fill warning" style="background-color: #ffc107 !important;"
                                  [style.width.%]="((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject || 0) * 100) / ((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.total || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending || 0) || 1)">
                                </div>
                              </div>
                              <div class="progress-value">{{dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject}}</div>
                            </div>
                            <div class="progress-item">
                              <div class="progress-label">
                                <span style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    background-color: #b91c1c;
                                    border-radius: 2px;
                                    margin-right: 8px;
                                  "></span>
                                Pending
                              </div>
                              <div class="progress-bar-container">
                                <div class="progress-bar-fill danger"
                                  [style.width.%]="((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending || 0) * 100) / ((+dashboardDetails?.SUBMISSION_ACTION_STATUS?.total || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject || 0) + (+dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending || 0) || 1)">
                                </div>
                              </div>
                              <div class="progress-value">{{dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending}}</div>
                            </div>

                            <div class="summary-stats">
                              <div class="summary-stat">
                                <div class="summary-number success">
                                  {{dashboardDetails?.SUBMISSION_ACTION_STATUS?.total}}</div>
                                <div class="summary-label">Completed</div>
                              </div>
                              <div class="summary-stat">
                                <div class="summary-number warning" style="color: #ffc107 !important;">
                                  {{dashboardDetails?.SUBMISSION_ACTION_STATUS?.reject}}</div>
                                <div class="summary-label">In Progress</div>
                              </div>
                              <div class="summary-stat">
                                <div class="summary-number danger">
                                  {{dashboardDetails?.SUBMISSION_ACTION_STATUS?.pending}}</div>
                                <div class="summary-label">Pending</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Replaced system notifications with gender distribution pie chart -->
                      <div class="col-md-6 mb-2">
                        <div class="chart-card h-100">
                          <div class="chart-header">
                            <i class="fas fa-chart-pie me-2"></i>
                            <div>
                              <div class="chart-title">Gender Distribution</div>
                              <div class="chart-subtitle">
                                Learner gender distribution in subcounty
                              </div>
                            </div>
                          </div>
                          <div class="chart-body">
                            <div class="pie-chart-container">
                              <div class="pie-chart">
                                <svg width="200" height="200" viewBox="0 0 200 200">
                                  <circle cx="100" cy="100" r="80" fill="none" stroke="#e9ecef" stroke-width="40" />


                                  <circle cx="100" cy="100" r="80" fill="none" stroke="#00adee" stroke-width="40"
                                    [attr.stroke-dasharray]="((dashboardDetails?.GENDER_DISTRIBUTION?.reject || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1) + ' 502.4'"
                                    stroke-dashoffset="0" transform="rotate(-90 100 100)" />
                                  <circle cx="100" cy="100" r="80" fill="none" stroke="#b91c1c" stroke-width="40"
                                    [attr.stroke-dasharray]="((dashboardDetails?.GENDER_DISTRIBUTION?.pending || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1) + ' 502.4'"
                                    [attr.stroke-dashoffset]="'-' + ((dashboardDetails?.GENDER_DISTRIBUTION?.reject || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1)"
                                    transform="rotate(-90 100 100)" />
                                </svg>
                                <div class="pie-center">
                                  <div class="pie-total">{{dashboardDetails?.GENDER_DISTRIBUTION?.total}}</div>
                                  <div class="pie-label">Total Learners</div>
                                </div>
                              </div>
                              <div class="pie-legend">
                                <div class="legend-item">
                                  <span class="legend-color" style="background-color: #00adee"></span>
                                  <span class="legend-text">Male: {{dashboardDetails?.GENDER_DISTRIBUTION?.reject}}
                                    ({{((dashboardDetails?.GENDER_DISTRIBUTION?.reject || 0) * 100) /
                                    ((dashboardDetails?.GENDER_DISTRIBUTION?.total || 0) || 1) |
                                    number:'1.0-0'}}%)</span>
                                </div>
                                <div class="legend-item">
                                  <span class="legend-color" style="background-color: #b91c1c"></span>
                                  <span class="legend-text">Female: {{dashboardDetails?.GENDER_DISTRIBUTION?.pending}}
                                    ({{((dashboardDetails?.GENDER_DISTRIBUTION?.pending || 0) * 100) /
                                    ((dashboardDetails?.GENDER_DISTRIBUTION?.total || 0) || 1) |
                                    number:'1.0-0'}}%)</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-12 mb-2">
                        <div class="chart-card h-100">
                          <div class="chart-header">
                            <i class="fas fa-chart-bar me-2"></i>
                            <div>
                              <div class="chart-title">
                                Institutions per Constituency in Subcounty
                              </div>
                              <div class="chart-subtitle">
                                Distribution of institutions across
                                constituencies in Westlands Subcounty
                              </div>
                            </div>
                          </div>
                          <div class="chart-body">
                            <div class="row">
                              <div class="col-lg-12 text-center">
                                <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels"
                                  [options]="barChartOptions" [chartType]="barChartType" [legend]="false">
                                </canvas>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="quick-actions">
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div class="mb-3 mb-md-0">
                              <div class="actions-title">Quick Actions</div>
                              <div class="actions-subtitle">
                                Manage subcounty educational operations
                                efficiently
                              </div>
                            </div>
                            <div class="action-buttons">
                              <button class="action-btn" (click)="navigationISUrl(0)">
                                <i class="fas fa-clipboard-check"></i>
                                <span>Review Applications</span>
                              </button>
                              <button class="action-btn">
                                <i class="fas fa-chart-line"></i>
                                <span>Generate Reports</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>